import React from 'react';
import { Shield, Wrench, Handshake, Eye, Zap } from 'lucide-react';
import { WHY_PILLARS } from '../mock';

const PILLAR_ICONS = [Shield, Wrench, Handshake, Eye, Zap];

const WhyExcelence = () => {
  return (
    <section id="why" data-testid="why-excelence-section" className="relative bg-[#0A1628] py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 circuit-bg-dark opacity-30" />
      <div className="absolute -top-40 -left-40 w-[30rem] h-[30rem] rounded-full bg-[#2AA8E8]/10 blur-3xl" />
      <div className="absolute -bottom-40 -right-40 w-[32rem] h-[32rem] rounded-full bg-[#D4A24C]/10 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-3xl mb-14">
          <span className="text-[11px] font-bold uppercase tracking-[0.3em] text-[#D4A24C]">Why Excelence Inc?</span>
          <h2 className="mt-3 text-3xl md:text-5xl font-extrabold text-white leading-[1.05]">
            The <span className="gold-text">Gold Standard</span> in<br className="hidden md:block" /> U.S. Transportation
          </h2>
          <p className="mt-4 text-base md:text-lg text-white/70 leading-relaxed">
            Five disciplines that separate professional logistics from everyone else in the market.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {WHY_PILLARS.map((p, i) => {
            const Icon = PILLAR_ICONS[i] || Shield;
            const isFeatured = i === 0;
            return (
              <div
                key={p.n}
                data-testid={`pillar-${p.n}`}
                className={`group relative rounded-2xl p-6 md:p-7 border backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 ${
                  isFeatured
                    ? 'bg-gradient-to-br from-[#2AA8E8]/15 to-[#D4A24C]/10 border-[#2AA8E8]/40 md:row-span-2'
                    : 'bg-white/[0.03] border-white/10 hover:border-[#D4A24C]/40 hover:bg-white/[0.06]'
                }`}
              >
                <div className="flex items-start justify-between mb-5">
                  <div className="w-12 h-12 rounded-xl bg-[#0A1628] border border-[#2AA8E8]/30 flex items-center justify-center group-hover:border-[#D4A24C] transition-colors">
                    <Icon className="w-5 h-5 text-[#2AA8E8] group-hover:text-[#D4A24C] transition-colors" />
                  </div>
                  <div className="text-4xl md:text-5xl font-extrabold text-white/10 group-hover:text-[#D4A24C]/20 transition-colors tracking-tight">
                    {p.n}
                  </div>
                </div>
                <h3 className="text-xl md:text-2xl font-extrabold text-white mb-2.5 leading-tight">
                  {p.title}
                </h3>
                <p className="text-sm md:text-base text-white/70 leading-relaxed">
                  {p.copy}
                </p>
                {isFeatured && (
                  <div className="mt-6 pt-6 border-t border-white/10">
                    <div className="text-[10px] font-bold uppercase tracking-widest text-[#D4A24C] mb-2">
                      Operational discipline
                    </div>
                    <div className="flex flex-wrap gap-2">
                      {['Route optimization', 'Load monitoring', 'SLA tracking', 'Exception handling'].map((t) => (
                        <span key={t} className="text-[11px] font-semibold text-white/80 bg-white/10 border border-white/15 rounded-full px-3 py-1">
                          {t}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyExcelence;
